module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('shared-provide-variation', {
    attrs: {
      "variation": _vm.variation,
      "fromModule": _vm.fromModule,
      "toModule": _vm.toModule,
      "disabledInputList": _vm.variation.match ? _vm.disabledInputList : []
    },
    on: {
      "change": _vm.emitToParent
    }
  }, [_c('div', {
    staticClass: "divider"
  }, [_c('span', [_vm._v("Atributos")])]), _vm._v(" "), _c('div', {
    staticClass: "l-row"
  }, [_c('form-group', {
    attrs: {
      "label": _vm.$t("manufacturerReference.label"),
      "columns": 3,
      "error": _vm.getError('manufacturerReference', _vm.variation.sku),
      "required": true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.variation.manufacturerReference),
      expression: "variation.manufacturerReference"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text",
      "disabled": _vm.disabledInputs()
    },
    domProps: {
      "value": (_vm.variation.manufacturerReference)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.variation, "manufacturerReference", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": _vm.$t("crossDocking.label"),
      "columns": 3,
      "error": _vm.getError('crossDocking', _vm.variation.sku)
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.variation.crossDocking),
      expression: "variation.crossDocking"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text",
      "disabled": _vm.disabledInputs()
    },
    domProps: {
      "value": (_vm.variation.crossDocking)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.variation, "crossDocking", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.variation.colors) ? _c('form-group', {
    attrs: {
      "label": _vm.$t("colorMap.label"),
      "columns": 3,
      "error": _vm.getError('attributes.colorMap', _vm.variation.sku),
      "required": true
    }
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.variation.colors,
      "track-by": "code",
      "label": "label",
      "selectLabel": "Clique",
      "selectedLabel": "Selecionado",
      "placeholder": "Selecione a opção",
      "disabled": _vm.disabledInputs()
    },
    model: {
      value: (_vm.colorMap),
      callback: function($$v) {
        _vm.colorMap = $$v
      },
      expression: "colorMap"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.variation.attributes.hasOwnProperty('color')) ? _c('form-group', {
    attrs: {
      "label": _vm.$t("color.label"),
      "columns": 3,
      "error": _vm.getError('attributes.color', _vm.variation.sku)
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.variation.attributes.color),
      expression: "variation.attributes.color"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text",
      "disabled": _vm.disabledInputs()
    },
    domProps: {
      "value": (_vm.variation.attributes.color)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.variation.attributes, "color", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.variation.sizes) ? _c('form-group', {
    attrs: {
      "label": _vm.$t("sizeMap.label"),
      "columns": 3,
      "error": _vm.getError('attributes.sizeMap', _vm.variation.sku),
      "required": true
    }
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.variation.sizes,
      "track-by": "code",
      "label": "label",
      "selectLabel": "Clique",
      "selectedLabel": "Selecionado",
      "placeholder": "Selecione a opção",
      "disabled": _vm.disabledInputs()
    },
    model: {
      value: (_vm.sizeMap),
      callback: function($$v) {
        _vm.sizeMap = $$v
      },
      expression: "sizeMap"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.variation.attributes.hasOwnProperty('size')) ? _c('form-group', {
    attrs: {
      "label": _vm.$t("size.label"),
      "columns": 3,
      "error": _vm.getError('attributes.size', _vm.variation.sku)
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.variation.attributes.size),
      expression: "variation.attributes.size"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text",
      "disabled": _vm.disabledInputs()
    },
    domProps: {
      "value": (_vm.variation.attributes.size)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.variation.attributes, "size", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('form-group', {
    attrs: {
      "required": true,
      "label": _vm.$t('gender.label'),
      "columns": 3,
      "error": _vm.getError('gender', _vm.variation.sku)
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.variation.gender),
      expression: "variation.gender"
    }],
    staticClass: "form-select",
    attrs: {
      "disabled": _vm.disabledInputs()
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.variation, "gender", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v(_vm._s(_vm.$t('choose.label')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "unisex"
    }
  }, [_vm._v(_vm._s(_vm.$t('gender.unisex.label')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "female"
    }
  }, [_vm._v(_vm._s(_vm.$t('gender.female.label')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "male"
    }
  }, [_vm._v(_vm._s(_vm.$t('gender.male.label')))])])]), _vm._v(" "), _vm._l((_vm.variation.amazonAttributes), function(attribute, index) {
    return _c('form-group', {
      key: attribute.id,
      attrs: {
        "required": attribute.required,
        "label": attribute.label,
        "columns": 3,
        "error": _vm.getError(("attributes." + (attribute.id)), _vm.variation.sku)
      }
    }, [_c('div', {
      staticClass: "form-flex"
    }, [(attribute.hasOwnProperty('values') && attribute.values.length) ? _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (attribute.value),
        expression: "attribute.value"
      }],
      staticClass: "form-select",
      attrs: {
        "disabled": _vm.disabledInputs()
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(attribute, "value", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      attrs: {
        "value": "undefined"
      }
    }, [_vm._v(_vm._s(_vm.$t('choose.label')))]), _vm._v(" "), _vm._l((attribute.values), function(option) {
      return _c('option', {
        domProps: {
          "value": option
        }
      }, [_vm._v(_vm._s(option))])
    })], 2) : (attribute.type === 'dateTime') ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (attribute.value),
        expression: "attribute.value"
      }],
      staticClass: "form-input",
      attrs: {
        "type": "datetime-local",
        "disabled": _vm.disabledInputs()
      },
      domProps: {
        "value": (attribute.value)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(attribute, "value", $event.target.value)
        }
      }
    }) : _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (attribute.value),
        expression: "attribute.value"
      }],
      staticClass: "form-input",
      attrs: {
        "type": "text",
        "disabled": _vm.disabledInputs()
      },
      domProps: {
        "value": (attribute.value)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(attribute, "value", $event.target.value)
        }
      }
    }), _vm._v(" "), (attribute.unitMeasure !== null) ? _c('span', {
      staticClass: "form-addon"
    }, [_vm._v(_vm._s(attribute.unitMeasure))]) : _vm._e()])])
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-09316220","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/marketplace/amazon/provide/Variation.vue
// module id = 2887
// module chunks = 0